import { ROLES as R } from "../core/roles";
import { lud, rule } from "../core/rule";
import { SCOPES } from "../core/scope";

export const saledItemPermissions = {
  view: "saledItem.view",
  create: "saledItem.create",
  delete: "saledItem.delete",
};

// Sold-item records carry the restaurant's public id in `sId` (written from the store
// the importer picked), so create and delete are bound to that restaurant (NA-011).
export const saledItemGrants = {
  "saledItem.view": rule(lud(R.MENU_SP, R.DMM, R.SALES, R.STORE, R.NEW)),
  "saledItem.create": rule(lud(R.DMM, R.MENU_SP), { scope: SCOPES.RESTAURANT }),
  "saledItem.delete": rule(lud(R.DMM), { scope: SCOPES.RESTAURANT }),
};
